import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss'
import * as classNames from 'classnames';
import responsive from 'src/Constants/responsive';
import ListItem from './ListItem';
// import stylesheet, { directions } from 'src/Constants/stylesheet';
import spacing from 'src/Constants/spacing';
import { MouseWheelHandler } from 'src/MouseWheelHandler';
import * as Hammer from 'hammerjs';

export type ListProps = {
    page: ListDto;
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden'
    },
    legend: {
        flex: '0 0 auto',
        height: 115,
        // ...stylesheet.MarginGutter(.5, directions.sides)
    },
    legendText: {
        display: 'block',
        maxWidth: spacing.MaxWidthText,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        opacity: 0,
        transition: 'opacity .3s ease',
        [responsive.Mobile]: {
            display: 'none'
        },
        [responsive.AfterMobile]: {
            paddingTop: 33,
            marginLeft: 175
        }
    },
    legendTextShow: {
        opacity: 1,
    },
    mobileLegendContainer: {
        position: 'relative',
        [responsive.Mobile]: {
            paddingTop: 33,
            display: 'flex',
            flexDirection: 'column',
            margin: `0 ${spacing.Gutter.Mobile}px`
        },
        [responsive.AfterMobile]: {
            display: 'none'
        }
    },
    mobileLegend: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        transform: 'translateY(-100%)',
        opacity: 0,
        transition: 'opacity .3s ease',
        '&:first-child': {
            transform: 'translateY(0)',
        }
    },
    mobileLegendActive: {
        opacity: 1,
    },
    itemsContainer: {
        marginTop: 'auto',
        [responsive.Mobile]: {
            marginBottom: spacing.Gutter.Mobile,
            marginLeft: spacing.Gutter.Mobile,
            marginRight: spacing.Gutter.Mobile
        },
        [responsive.AfterMobile]: {
            marginBottom: spacing.Gutter.Desktop / 2,
            marginLeft: spacing.Gutter.Desktop / 2,
            marginRight: spacing.Gutter.Desktop / 2
        },
    },
    items: {
        position: 'relative',
        overflow: 'hidden',
        height: 0,
        [responsive.Mobile]: {
            paddingBottom: '100%'
        },
        [responsive.MobileHorizontal]: {
            paddingBottom: '30%'
        },
        [responsive.Laptop]: {
            paddingBottom: '50%'
        },
        [responsive.Desktop]: {
            paddingBottom: '40%'
        }
    },
    itemsInner: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexWrap: 'wrap',
        cursor: 's-resize',
        transition: 'all ease 0.3s'
    },
    lastLine: {
        cursor: 'n-resize',
    }
}
type Props =
    ListProps &
    StyledComponentProps<keyof typeof styles>;

type State = {
    legend?: string,
    legebdVisible: boolean,
    currentLine: number
};

class List extends React.PureComponent<Props, State> {

    private container: React.RefObject<HTMLDivElement>;
    private MouseWheelHandler: MouseWheelHandler;
    private hammer: HammerManager;

    constructor(props: Props) {
        super(props);

        this.container = React.createRef();

        this._onHover = this._onHover.bind(this);
        this._getRowsCount = this._getRowsCount.bind(this);

        this._handleKeydown = this._handleKeydown.bind(this);
        this._Next = this._Next.bind(this);
        this._Previous = this._Previous.bind(this);

        this.state = {
            legend: '',
            legebdVisible: false,
            currentLine: 0
        }
    }

    componentDidMount() {
        window.addEventListener('keydown', this._handleKeydown);

        if (!this.MouseWheelHandler) {
            this.MouseWheelHandler = new MouseWheelHandler(this._Previous.bind(this), this._Next.bind(this));
        }
        this.MouseWheelHandler.listen();

        const { container: { current } } = this;
        if (!this.hammer && current) {
            this.hammer = new Hammer(current);
            this.hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });
            this.hammer.on("swipe", this._OnSwipe.bind(this));
        }
    }

    componentDidUpdate() {
        const { currentLine } = this.state;

        const count = this._getRowsCount();
        if (!count) { return }

        const container: HTMLDivElement | null = document.querySelector("[data-items-inner]");
        if (!container) { return }

        container.style.transform =
            "translateY(" + (-100 / count) * currentLine + "%)";
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this._handleKeydown);

        if (this.MouseWheelHandler) {
            this.MouseWheelHandler.unlisten();
        }

        if (this.hammer) {
            this.hammer.destroy();
        }
    }
    public render() {
        const { classes, page: { Projects, UID } } = this.props;
        const { legend, legebdVisible, currentLine } = this.state;

        const count = this._getRowsCount();

        return (
            <div className={classNames(classes!.container)}>
                <div className={classes!.legend}>
                    <span
                        className={classNames(classes!.legendText, legebdVisible ? classes!.legendTextShow : null)}
                    >
                        {legend}
                    </span>
                    <div className={classes!.mobileLegendContainer}>
                        {Projects.map((p, i) =>
                            <div
                                key={p.UID}
                                className={
                                    classNames(
                                        classes!.mobileLegend,
                                        i === currentLine ? classes!.mobileLegendActive : null)}
                                style={{ transform: `translateY(-${i * 100}%)` }}
                            >
                                {p.PreviewText}
                            </div>
                        )}
                    </div>
                </div>
                <div className={classes!.itemsContainer}>
                    <div className={classes!.items}>
                        <div
                            className={classNames(classes!.itemsInner, 
                                (count !== undefined && currentLine >=  count - 2) ? classes!.lastLine : '' )}
                            data-items-inner=""
                            ref={this.container}
                        >
                            {Projects.map(p =>
                                <ListItem
                                    key={p.UID}
                                    project={p}
                                    parentUID={UID}
                                    onMouseEnter={(l) => this._onHover(l)}
                                    onMouseLeave={() => this.setState({ legend: '', legebdVisible: false })}
                                />)
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private _onHover(legend: string) {
        if (!legend) { return }

        this.setState({ legend, legebdVisible: true });
    }

    private _getRowsCount() {
        const container = document.querySelector("[data-items-inner]");
        if (!container) { return }

        const item = container.firstElementChild;
        if (!item) { return }

        const h = container.clientHeight;
        return Math.round(h / item.clientHeight);
    }

    private _Go(i: number) {
        this.setState(() => ({
            currentLine: i
        }));
    }

    private _Next() {
        const { currentLine } = this.state;
        const count = this._getRowsCount();

        if (!count) { return };

        if (currentLine < count - 2) {
            this._Go(currentLine + 1);
        }
    }

    private _Previous() {
        const { currentLine } = this.state;
        if (currentLine >= 1) {
            this._Go(currentLine - 1);
        }
    }
    private _handleKeydown(e: KeyboardEvent) {
        switch (e.keyCode) {
            // up
            case 38:
                this._Previous();
                break;
            // down
            case 40:
                this._Next();
                break;
            default:
                break;
        }
    }

    private _OnSwipe(ev: HammerInput) {
        if (ev.direction === Hammer.DIRECTION_UP) {
            this._Next();
        } else {
            this._Previous();
        }
    }
}

export default withStyles(styles)(List);


// WEBPACK FOOTER //
// ./src/Components/List.tsx